/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import { Box, Button, Link, Stack, Tab } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ContentLayout,
  CustomeDialog as CustomDialog,
  CustomTable,
  HeaderBreadcrumbs,
} from "../../../shared";
import { useList } from "../hooks/useList";
import InputControl from "../../../shared/components/InputControl";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ApproveAndRemoveAlertBox } from "../components/ApproveAndRemoveAlertBox";
import { PlAndBsListFilterSection } from "../components";

export const ListDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isStoreAdmin = location.pathname.includes("/store-admin");

  const {
    state,
    handleSearch,
    onSeachClear,
    handlePSAndBSReportList,
    isCreateVisible,
    isEditable,
    setCurentTab,
    currentTab,
    handleOpenAlert,
    handleApplyFilter,
    handleClearAllFilter,
    handleClearFilter,
    handleChangeFilter,
  } = useList({
    isList: true,
    isStore: isStoreAdmin,
  });

  const ActionButtons = ({ id }) => {
    return (
      isEditable && (
        <img
          alt="details"
          src="/icons/arrow_forward.svg"
          onClick={() => navigate(`edit/${id}`)}
        />
      )
    );
  };

  const columns = React.useMemo(() => {
    const accountUploadReports = [
      {
        Header: "Month ",
        accessor: "month",
      },
      {
        Header: "Financial Year",
        accessor: "year",
      },
      {
        Header: "File",
        accessor: "excel_file",
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                textDecoration: "none",
                cursor: "pointer",
                color: "blue",
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
            >
              <Link
                underline="none"
                component="button"
                variant="body2"
                onClick={() => {
                  handlePSAndBSReportList(row?.original?.id);
                }}
              >
                <b>Download</b>
              </Link>
            </Box>
          );
        },
      },
      {
        Header: "Submitted By",
        accessor: "user_name",
      },
      {
        Header: "Last Uploaded on",
        accessor: "last_updated_on",
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        disableGlobalFilter: true,
        accessor: (row) => {
          return <ActionButtons id={row.id} />;
        },
      },
    ];

    // Conditionally add the "Store" column for non-store admins
    if (!isStoreAdmin) {
      accountUploadReports.unshift({
        Header: "Store",
        accessor: "store_name",
      });
    }

    return accountUploadReports;
  }, [isStoreAdmin]);

  const RequestColumnActionButtons = ({ id }) => {
    return (
      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <Button
          variant="outlined"
          onClick={() => {
            handleOpenAlert(true);
          }}
        >
          Approve/Reject
        </Button>
      </div>
    );
  };

  const requestColumns = React.useMemo(
    () => [
      {
        Header: "Submission Date",
        accessor: "",
      },
      {
        Header: "Store",
        accessor: "store_name",
      },
      {
        Header: "Month ",
        accessor: "month",
      },
      {
        Header: "Financial Year",
        accessor: "year",
      },
      {
        Header: "File",
        accessor: "excel_file",
        Cell: ({ row }) => {
          return (
            <Box
              sx={{
                textDecoration: "none",
                cursor: "pointer",
                color: "blue",
              }}
            >
              <Link
                underline="none"
                component="button"
                variant="body2"
                onClick={() => handlePSAndBSReportList(row?.original?.id)}
              >
                <b>Download</b>
              </Link>
            </Box>
          );
        },
      },
      {
        Header: "Submitted By",
        accessor: "",
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        disableGlobalFilter: true,
        accessor: (row, index) => {
          return <RequestColumnActionButtons id={row.id} />;
        },
      },
    ],
    []
  );

  const handleChange = (event, newValue) => {
    setCurentTab("listDetails", newValue);
  };

  return (
    <ContentLayout
      title="PL & BS List"
      breadcrumbs={
        <HeaderBreadcrumbs
          links={[
            { name: "Dashboard", href: "/" },
            { name: "PL & BS List" },
          ]}
        />
      }
      rightContent={
        isCreateVisible && (
          <Button
            type="button"
            size="medium"
            variant="contained"
            onClick={() => navigate("create")}
          >
            Upload
          </Button>
        )
      }
    >
      <TabContext value={currentTab}>
        <Box
          className="sticky-Tab"
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            top: "88px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <TabList onChange={handleChange}>
            <Tab label="Account Uploads" value="1" />
            {/* <Tab
              label={
                <div style={{ display: "flex", alignItems: "center" }}>
                  Overwrite Requests
                  <span
                    style={{
                      marginLeft: "4px",
                      background: "#1560D4",
                      color: "#FFFFFF",
                      borderRadius: "50%",
                      padding: "4px 4px",
                      fontSize: "12px",
                    }}
                  >
                    05
                  </span>
                </div>
              }
              value="2"
            /> */}
          </TabList>
        </Box>
        <TabPanel sx={{ px: "0" }} value="1">
          <CustomTable
            columns={columns}
            data={state?.accountList}
            defaultSearch={false}
            isLoading={state?.isBusy}
            filterContent={
              <InputControl
                type="table-search"
                placeholder="Search"
                value={state?.searchText}
                onChange={(e) => handleSearch(e.target.value)}
                onClear={onSeachClear}
              />
            }
            filterSection={
              <Stack
                width="100%"
                gap="16px"
                flexDirection={{ md: "row", xs: "column" }}
              >
                <Stack
                  flexDirection="row"
                  gap="16px"
                  flexGrow={1}
                  maxWidth={{ md: "70%", xs: "100%" }}
                >
                  <PlAndBsListFilterSection
                    state={state}
                    accountMonthList={true}
                    financialYearList={true}
                    storeList={!isStoreAdmin}
                    handleChangeFilter={handleChangeFilter}
                  />
                </Stack>
                <Stack
                  flexDirection="row"
                  gap="14px"
                  alignItems="center"
                  ml="auto"
                >
                  <Button
                    size="large"
                    variant="contained"
                    onClick={() => handleApplyFilter(state.filter.values)}
                    disabled={state.filter.isFilterApplied}
                  >
                    Apply
                  </Button>
                </Stack>
              </Stack>
            }
            filterApplied={state.appliedFilters}
            onAllFilterClear={handleClearAllFilter}
            onFilterClear={handleClearFilter}
            onRowLink={(row) => `edit/${row.id}`}
          />
        </TabPanel>
        <TabPanel sx={{ px: "0" }} value="2">
          <CustomTable
            columns={requestColumns}
            data={state?.accountList}
            defaultSearch={false}
            isLoading={state?.isBusy}
            filterContent={
              <InputControl
                type="table-search"
                value={state?.searchText}
                onChange={(e) => handleSearch(e.target.value)}
                onClear={onSeachClear}
              />
            }
            // filterSection={
            //   <PlAndBsListFilterSection
            //     storeList
            //     accountMonthList
            //     financialYearList
            //     state={state}
            //     getAppliedFilter={getAppliedFilter}
            //     handleApplyFilter={handleApplyFilter}
            //     handleChangeFilter={handleChangeFilter}
            //   />
            // }
            // filterApplied={state.appliedFilters}
            // onAllFilterClear={handleClearAllFilter}
            // onFilterClear={handleClearFilter}
          />
        </TabPanel>
      </TabContext>

      <CustomDialog
        open={state.isRejectDialogOpen || state.isApproveDialogOpen}
        handleClose={handleOpenAlert}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: "423px",
            height: "167px",
            p: "24px 16px",
          },
        }}
        title={"Account File Overwrite Request"}
        content={
          <ApproveAndRemoveAlertBox
            handleOpenAlert={handleOpenAlert}
            state={state}
          />
        }
      />
    </ContentLayout>
  );
};
